<template>
  <component
    :is="isValid ? 'a' : 'div'"
    :href="isValid ? organizationLink : null"
    class="organization-card"
    @click="!isValid && $emit('select', organization)"
  >
    <div class="organization-info-container">
      <div
        :style="
          isValid
            ? {
              backgroundImage: 'url(' + organization.logo + ')',
              backgroundColor: 'transparent',
            }
            : {
              backgroundColor: '#D9D9D9',
            }
        "
        justify-center
        align-end
        class="image-container"
      />
      <div class="organization-info-text-container">
        <h3 class="organization-info-title">
          {{ isValid ? organization.publicName : adminText('organizationAll.needs_update_871f842a', 'Needs update!') }}
        </h3>
        <h5 class="organization-info-legal-name">{{ organization.legalName }}</h5>
      </div>
      <div
        v-if="isValid"
        class="default-icon-container"
        @click.stop="$emit('toggleDefault', organization)"
      >
        <img
          v-if="organization.userOrganization.default"
          class="default-icon"
          src="/assets/default-star-filled-icon.svg"
          :alt="adminText('organizationAll.icon_716f63b9', 'Icon')"
        >
        <img
          v-else
          class="default-empty-icon"
          src="/assets/default-star-empty-icon.svg"
          :alt="adminText('organizationAll.icon_716f63b9', 'Icon')"
        >
      </div>
    </div>
    <div class="organization-sub-info-container">
      <div class="organization-live-events">
        {{ liveEventsLabel }}
      </div>
      <div
        v-if="isValid"
        class="create-event-button"
        @click.stop="$emit('createEvent', organization)"
      >
        <img src="/assets/add.svg" :alt="adminText('organizationAll.add_icon_42b71d9e', 'add icon')" class="add-icon">
        {{ adminText('organizationAll.create_event_6f1d19d0', 'CREATE EVENT') }}
      </div>
    </div>
  </component>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { OrganizationType } from '@/types'

export default {
  mixins: [OrganizationLocalization],
  name: 'organization-card',
  props: {
    organization: Object,
    isValid: { type: Boolean, default: true },
  },
  computed: {
    liveEventsLabel() {
      const count = this.organization.liveEventsCount
      if (count === 0) return this.adminText('organizationAll.no_live_events_276be23d', 'No live events')
      if (count === 1) return this.adminText('organizationAll.count_live_event_34adf6a5', '{{count}} live event', { count })
      if (count % 10 === 1 && count % 100 !== 11) return this.adminText('organizationAll.liveEventsSingularMany', '{{count}} live events', { count })
      if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 12 || count % 100 > 14)) return this.adminText('organizationAll.count_live_events_03e607ef', '{{count}} live events', { count })

      return this.adminText('organizationAll.liveEventsMany', '{{count}} live events', { count })
    },
    organizationLink() {
      if (this.organization.type === OrganizationType.THEATER) {
        return `/theater-organizations/${this.organization.slug}`
      }

      const prefix = this.organization.type === OrganizationType.SPORT_ORGANIZATION ? 'sport-' : ''

      return `/${prefix}organizations/${this.organization.slug}`
    },
  },
}
</script>

<style scoped>
.organization-card {
  display: flex;
  flex-direction: column;
  max-width: 566px;
  width: 100%;
  border: 2px solid #d9d9d9;
  border-radius: 1rem;
  overflow: hidden;
  text-decoration: none;
}
.organization-card:hover {
  cursor: pointer;
  border: 2px solid #cee4f2;
}
.organization-card:hover .organization-info-container {
  background-color: #e6f1f8;
}
.organization-info-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background-color: #f5f5f5;
}
.organization-info-text-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
.organization-info-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.organization-info-legal-name {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.image-container {
  height: 2rem;
  width: 2rem;
  border-radius: 1rem !important;
  background-size: cover;
}
.organization-sub-info-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 1rem;
}
.organization-live-events {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 150%;
  color: #666666;
}
.add-icon {
  filter: brightness(0) saturate(100%) invert(25%) sepia(66%) saturate(4280%) hue-rotate(187deg)
    brightness(96%) contrast(98%);
}
.create-event-button {
  padding: 12px 24px;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.create-event-button:hover {
  cursor: pointer;
  background-color: #e6f1f8;
  border-radius: 24px;
}
.default-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 32px;
}
.default-icon-container:hover {
  cursor: pointer;
}
.default-empty-icon {
  filter: invert(98%) sepia(0%) saturate(1807%) hue-rotate(210deg) brightness(110%) contrast(70%);
}
.default-empty-icon:hover {
  filter: invert(22%) sepia(44%) saturate(4972%) hue-rotate(187deg) brightness(104%) contrast(98%);
}
</style>
